import { IContactsConfig } from "@/config/contacts.config";

// Spain-specific contacts configuration override
export const spainContactsConfig: Partial<IContactsConfig> = {
  phone: "+34603250826",
  email: "info@avezor.es",
  telegram: "https://t.me/avezor_spain",
  whatsapp: "https://wa.me/34603250826/",
  viber: "viber://chat?number=+34603250826",
  address: {
    en: "Gran Vía 1, Madrid",
    el: "Gran Vía 1, Μαδρίτη",
    ru: "Гран Виа 1, Мадрид",
    es: "Gran Vía 1, Madrid",
  },
  location: {
    city: "Madrid",
    country: "Spain",
  },
};

export default spainContactsConfig;
